import { User } from './User';
import { FitnessGoalType, PhotoIdType } from '../../Shared/fb.enum';
import { ICommonImage } from '../CommonImage';
import { UserMembershipPlan } from './UserMembershipPlan';
import { UserMeasurement } from './UserMeasurement';
import { MemberInvoice } from './MemberInvoice';
import { Employee } from './Employee';
import { Reminder } from '../Common/Reminder';
import { UserStage } from '../Common/UserStage';
import { UserStatus } from '../Common/UserStatus';
import { FitnessGoal } from './FitnessGoal';
import { Routine } from './Routine';
import { RoutineSeries } from './RoutineSeries';

export class Member extends User {
  MembershipId: number;
  ReferredBy: User;
  MembershipStartDate: Date;
  MembershipExpiryDate: Date;
  EnrolledBy: User;
  UserMemberships: UserMembershipPlan[];
  Goal: FitnessGoal;  
  PhotoIdType: PhotoIdType;
  PhotoIdValue: string;
  AddressTypeId: PhotoIdType;
  AddressIdValue: string;
  Remarks: string;
  UserImages: ICommonImage[];
  Measurements: UserMeasurement[];
  InvoiceDetails: MemberInvoice[];
  AssignedTrainer: Employee;
  AssignedDietician: Employee;
  Reminders: Reminder[];
  Followups: Reminder[];
  NextFollowUpDate: Date;
  FollowUpRemarks: string;
  Stage: UserStage;
  UserStatus: UserStatus;
  UserSubStatus: UserStatus;
  TotalBalance: number;
  FollowUpReason: string;
  FollowUpFeedBackType: string;
  RoutineSeries: RoutineSeries;
  Routine: Routine;

}
